import http from "@/utils/httpRequest";

// let baseURL="/api/workbenchlh";
// 系统设置获取列表
export const apiwbprogressconfiglist = (params) => {
  return http.post(`/wbprogressconfig/list`, { ...params }, { baseURL });
};
// 系统设置删除
export const apiwbprogressconfigdelete = (params) => {
  return http.post(`/wbprogressconfig/delete`, { ...params }, { baseURL });
};

// 系统设置获取单条数据
export const apiwbprogressconfigget = (params) => {
  return http.get(`/wbprogressconfig/get?id=` + params, { baseURL });
};

// 系统设置保存数据
export const apiwbprogressconfigsave = (params) => {
  return http.post(`/wbprogressconfig/save`, { ...params }, { baseURL });
};

// 源列表入口获取列表
export const apiwbsystemconfiglist = (params) => {
  return http.post(`/wbsystemconfig/list`, { ...params }, { baseURL });
};
// 源列表入口删除
export const apiwbschedulemanagementDelete = (params) => {
  return http.post(`/wbsystemconfig/delete`, { ...params }, { baseURL });
};

// 源列表入口获取单条数据
export const apiwbsystemconfigget = (params) => {
  return http.get(`/wbsystemconfig/get?id=` + params, { baseURL });
};

// 源列表入口保存数据
export const apiwbsystemconfigsave = (params) => {
  return http.post(`/wbsystemconfig/save`, { ...params }, { baseURL });
};

// 便捷入口确定接口
export const apiwbconveniententrancesave = (params) => {
  return http.post(`/wbconveniententrance/save`, params, { baseURL });
};

// 项目完结项配置-列表
export const apiwbprojectendconfiglist = (params) => {
  return http.post(`/wbprojectendconfig/list`, params, { baseURL });
};

// 项目完结项配置-保存
export const apiwbprojectendconfigsave = (params) => {
  return http.post(`/wbprojectendconfig/save`, params, { baseURL });
};

// 项目完结项配置-详情
export const apiwbprojectendconfigget = (params) => {
  return http.get(`/wbprojectendconfig/get?id=${params}`, { baseURL });
};

// 工作日配置-获取数据
export const apiworkDaysInfolist = (params) => {
  return http.post(`/workDaysInfo/list`, params, { baseURL });
};

// 工作日配置-修改
export const apiworkDaysInfosave = (params) => {
  return http.post(`/workDaysInfo/save`, params, { baseURL });
};

// 快捷入口配置-列表
export const APIwbConvenientConfigList = (params) => {
  return http.post(`/wbConvenientConfig/list`, params, { baseURL });
};
// 快捷入口配置-详情
export const APIwbConvenientConfigGet = (params) => {
  return http.get(`/wbConvenientConfig/get?id=${params}`, { baseURL });
};
// 快捷入口配置-保存
export const APIwbConvenientConfigSave = (params) => {
  return http.post(`/wbConvenientConfig/save`, params, { baseURL });
};
// 快捷入口配置-删除
export const APIwbConvenientConfigDelete = (params) => {
  return http.post(`/wbConvenientConfig/delete`, params, { baseURL });
};
// 修改密码
export const APIUserChangePwd = (params) => {
  return http.post(`/api/api/user/changePwd`, params, { baseURL });
};
// 退出登录
export const APILogout = () => {
  return http.get(`/api/logout`, { baseURL });
};
